// extracted by mini-css-extract-plugin
export default {"izjaveContainer":"IzjavePolaznika_izjaveContainer__qCNPo","izjavaItem":"IzjavePolaznika_izjavaItem__lc7C5"};